// import { FETCH_VCF_DATA_BEGIN, FETCH_VCF_DATA_SUCCESS, FETCH_VCF_DATA_FAILURE } from '../actions/types';
// Replace above line with below:
import { FetchVcfDataBeginAction, FetchVcfDataSuccessAction, FetchVcfDataFailureAction } from '../actions';
import { VCard } from "../types/ParsedVCardTypes"

interface VcfState {
    vcards: VCard[];
    loading: boolean;
    error: string | null;
}

// Define initial state as VcfState
const initialState: VcfState = {
    vcards: [],
    loading: false,
    error: null,
};

// Use TypeScript in reducer
const vcfDataReducer = (
    state = initialState,
    action: FetchVcfDataBeginAction | FetchVcfDataSuccessAction | FetchVcfDataFailureAction
): VcfState => {
    switch (action.type) {
        case 'FETCH_VCF_DATA_BEGIN':
            return {
                ...state,
                loading: true,
                error: null
            };
        case 'FETCH_VCF_DATA_SUCCESS':
            return {
                ...state,
                loading: false,
                vcards: action.payload.data, // instead of 'data', use 'vcards' (defined in VcfState)
            };
        case 'FETCH_VCF_DATA_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                vcards: [], // clear previous VCard data. You can manage as per your needs.
            };
        default:
            return state;
    }
};

export default vcfDataReducer;